import Cookie from 'js-cookie';
import { isDev, isLocal, isProduction, isTest } from './environment';
const COOKIE_NAME = 'useOldLogin';

export const updateOldLoginCookie = (val: boolean) => {
  if (val) {
    Cookie.set(COOKIE_NAME, true, { expires: 1 });
  } else {
    Cookie.remove(COOKIE_NAME);
  }

  if (isLocal) {
    console.log('Old login cookie set to', !!val);
  }
};

export const shouldUseOldLogin = (): boolean => {
  return Cookie.get(COOKIE_NAME) === 'true';
};

export const getNewLoginUrl = (): URL => {
  const url = new URL('https://meinereisen.meinschiff.com/');

  if (isDev || isTest) {
    url.hostname = 'meinereisen.aws.test.meinschiff.com';
  } else if (isLocal) {
    url.protocol = 'http';
    url.hostname = 'localhost';
    url.port = '3000';
  }

  return url;
};
